module.exports = __webpack_public_path__ + "static/media/img2.ce1d0363.svg";